<template>
  <div class="container">
    <div class="main">
      <div class="headTitle">
        异议反馈
        <font size="1" color="#ff0000;">(提示：每家企业限异议一次)</font>
      </div>
      <div></div>
      <div class="formBox">
        <el-form :model="form2" label-width="160px">
          <el-form-item label="异议企业名称">{{form2.companyName}}</el-form-item>
          <el-form-item label="企业统一社会信用代码">{{form2.uscc}}</el-form-item>
          <el-form-item label="入库时间">{{form2.storageTime}}</el-form-item>
        </el-form>
        <el-form :model="form" :rules="rules" ref="formRef" label-width="160px">
          <el-form-item label="内容描述" prop="objecttionReason">
            <el-input
              v-model="form.objecttionReason"
              type="textarea"
              placeholder="请输入内容描述..."
              maxlength="600"
              show-word-limit
              :rows="8"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件">
            <FileUpload v-model="form.fileList" :limit="3" :fileType="['jpg','png','jpeg','pdf']"></FileUpload>
          </el-form-item>
          <!-- <el-form-item>
            <div class="downloadTemplate" @click="downloadTemplate">异议模板下载</div>                                        
          </el-form-item> -->
          <el-form-item>
            <div style="text-align: center;">
              <el-button type="primary" @click="close">关闭</el-button>
              <el-button type="primary" @click="submitForm('formRef')">提交</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { addIpmObjection, objectApplyView } from "@/api/index";
export default {
  name: "addFeedBack",
  data() {
    return {
      form: { fileList: [] },
      form2:{},
      rules: {
        objecttionReason: [
          { required: true, message: "请输入内容描述", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    objectApplyView(this.$route.query.id).then(res => {
      this.form2 = res.data;
    });
  },
  methods: {
    submitForm(formName) {
      this.form.applicationId = this.$route.query.id;
      this.form.fileList.forEach(e => {
        e.fileTypeCode = "OBJECTION_FILE";
        e.fileTypeName = "异议反馈附件";
      });
      this.$refs[formName].validate(valid => {
        if (valid) {
          addIpmObjection(this.form).then(res => {
            if (res.status == 200) {
              this.$message({ message: "提交成功", type: "success" });
              this.$router.push("/usercenter/objection");
            }
          });
        } else {
          return false;
        }
      });
    },
    close() {
      window.close();
    },
    downloadTemplate(){
        window.open(process.env.VUE_APP_URL + '/goldenseed/statics/异议模版.docx','_blank')
    },
  }
};
</script>
  
  <style>
.container {
  padding: 20px 0;
}
.main {
  width: 1200px;
  min-height: calc(100vh - 226px);
  margin: 0px auto;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px;
}
.headTitle {
  padding: 5px 20px;
  border-left: 4px solid #409eff;
  font-size: 20px;
  margin-bottom: 50px;
}
.downloadTemplate {
  color: #409eff;
  cursor: pointer;
}
.downloadTemplate:hover {
  color: #f00;
}
</style>